<!--企业数字化服务云平台-->
<template xmlns="http://www.w3.org/1999/html">
  <div class="platform-container">
    <headerIndex/>
    <div class="platform-content">
      <p class="SourceHanSansCN title">{{ pName }}
        <el-button round class="switch-btn" @click="switchNodes"><i class="iconfont icon-qiehuan" style="padding-right: 5px;"/>切换节点</el-button>
      </p>
      <el-row :gutter="16" class="sub-module">
        <el-col :span="12">
          <div class="col-12" style="padding: 20px">
            <p class="small-title SourceHanSansCN">公共法律服务
              <el-button round class="switch-btn" @click="legalService('http://www.cq.smegov.cn')">查看更多
                <i class="el-icon-right" style="padding-left: 5px;"></i>
              </el-button>
            </p>
            <el-row :gutter="16" class="left-row">
              <el-col :span="6">
                <div class="grid-content bg-purple" @click="legalService('http://www.cq.smegov.cn/#/MediationCommittee')">
                  <i class="icon-red">
                    <div class="icon-mediate"/>
                  </i>
                  <p class="SourceHanSansCN">申请调解</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple" @click="legalService('http://www.cq.smegov.cn')">
                  <i class="icon-red">
                    <div class="icon-consulting"/>
                  </i>
                  <p class="SourceHanSansCN">法律咨询</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple" @click="legalService('http://www.cq.smegov.cn')">
                  <i class="icon-red">
                    <div class="icon-subscribe"/>
                  </i>
                  <p class="SourceHanSansCN">预约律师</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple" @click="legalService('http://www.cq.smegov.cn')">
                  <i class="icon-red">
                    <div class="icon-law"/>
                  </i>
                  <p class="SourceHanSansCN">法律援助</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple" @click="projectCoach">
            <i class="icon-red">
              <div class="icon-coach"/>
            </i>
            <p class="SourceHanSansCN">项目辅导</p>
            <p class="statistics SourceHanSansCN"><span>{{ statistics.coach }}</span>项申报中</p>
            <p><i class="el-icon-right"></i></p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple" @click="cultivation">
            <i class="icon-red">
              <div class="icon-cultivation"/>
            </i>
            <p class="SourceHanSansCN">企业培育</p>
            <p class="statistics SourceHanSansCN"><span>{{ statistics.system }}</span>大辅导系统</p>
            <p><i class="el-icon-right"></i></p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple" @click="declaration">
            <i class="icon-red">
              <div class="icon-declare"/>
            </i>
            <p class="SourceHanSansCN">需求申报</p>
            <p class="statistics SourceHanSansCN"><span>{{ statistics.declare }}</span>项申报入库</p>
            <p><i class="el-icon-right"></i></p>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16" class="sub-module">
        <el-col :span="12">
          <div class="col-12" style="padding: 20px">
            <p class="small-title SourceHanSansCN">银企服务
              <el-button round class="switch-btn" @click="moreLoan">查看更多
                <i class="el-icon-right" style="padding-left: 5px;"></i>
              </el-button>
            </p>
            <el-row :gutter="16" style="margin-top: 15px;">
              <el-col :span="12" v-for="(bank,index) of bankEnterpriseService" v-if="index<4">
                <div class="small-12" @click="bankEnterpriseServiceDetails(bank)">
                  <p class="bold-p SourceHanSansCN">
                    <span>{{ bank.name }}</span>
                    <el-divider direction="vertical"/>
                    <span>最高{{ bank.maximumAmount }}万</span>
                  </p>
                  <p style="padding-bottom: 0px">{{ bank.tips }}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="col-12" style="padding: 20px">
            <p class="small-title SourceHanSansCN">云计算服务
              <el-button round class="switch-btn" @click="bangqiCloud">查看更多
                <i class="el-icon-right" style="padding-left: 5px;"></i>
              </el-button>
            </p>
            <el-row :gutter="16" style="margin-top: 15px;">
              <el-col :span="12">
                <div class="small-12" @click="bangqiCloud">
                  <i class="icon-red">
                    <div class="icon-ECS"/>
                  </i>
                  <p class="p-bold SourceHanSansCN">云服务器</p>
                  <p class="default-p">安全稳定，高弹性的计算服务</p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="small-12" @click="bangqiCloud">
                  <i class="icon-red">
                    <div class="icon-storage"/>
                  </i>
                  <p class="p-bold SourceHanSansCN">对象存储</p>
                  <p class="default-p">低成本的海量云端存储服务</p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="small-12" @click="bangqiCloud">
                  <i class="icon-red">
                    <div class="icon-server"/>
                  </i>
                  <p class="p-bold SourceHanSansCN">轻量应用服务器</p>
                  <p class="default-p">开箱即用，轻量应用场景首选</p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="small-12" @click="bangqiCloud">
                  <i class="icon-red">
                    <div class="icon-MySQL"/>
                  </i>
                  <p class="p-bold SourceHanSansCN">云数据库MySQL</p>
                  <p class="default-p">高性能、安全的云数据库</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row class="sub-module">
        <el-col :span="24" style="padding: 20px 0px" class="col-12">
          <p class="small-title SourceHanSansCN" style="padding: 0px 20px;">精选推荐
            <el-button round class="switch-btn" @click="moreService">更多服务
              <i class="el-icon-right" style="padding-left: 5px;"></i>
            </el-button>
          </p>
          <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
            <el-tab-pane v-for="tab of tabList" :name="'type'+tab.id">
              <span slot="label" class="SourceHanSansCN">{{ tab.name }}</span>
            </el-tab-pane>
          </el-tabs>
          <div class="recommend" v-if="recommends.length>0" ref="recommends">
            <el-row :gutter="16">
              <el-col :span="4" v-for="recommend of recommends">
                <div @click="productDetails(recommend)">
                  <el-image style="width: auto; height: 230px;border-radius: 8px;" :src="recommend.image" fit="contain"/>
                  <p class="recommend-title SourceHanSansCN">{{ recommend.name }}</p>
                  <div class="preferential-amount" v-if="recommend.usingDoor">
                    <div class="preferential">满{{ recommend.usingDoor }}减{{ recommend.preferentialAmount }}</div>
                  </div>
                  <p class="recommend-price SourceHanSansCN"><span>￥</span>{{ parseFloat(recommend.price).toFixed(2) }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="recommend" v-else>
            <el-empty description="暂无商品"/>
          </div>
          <!-- 分页 -->
          <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage" :limit="tablePage.pageSize"
                style="padding: 0px 25px 15px 10px;"/>
        </el-col>
      </el-row>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import page from "@/components/page/pages";
import {vsPlatformHome, newGetFirstAllGoods} from '@/api/cloudServiceApi'
import {classificationSonsOnes} from "@/api/systemSetting";
import $store from "@/store";

export default {
  name: "platform",
  components: {home_footer, headerIndex, Hang, page},
  data() {
    return {
      pName: '',
      parName: '',
      statistics: {
        coach: 25,
        system: 4,
        declare: 1
      },
      bankEnterpriseService: [
        {name: '普惠贷', maxPrice: '最高500万', content: '助力企业快速成长'},
        {name: '普惠贷', maxPrice: '最高500万', content: '稳固企业产业发展'},
        {name: '普惠贷', maxPrice: '最高500万', content: '解决项目资金短缺'},
        {name: '普惠贷', maxPrice: '最高500万', content: '帮扶企业经营纾困'},
      ],
      activeName: '',
      tabList: [],
      recommends: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      cid: 0,
    }
  },
  computed: {
    childNode() {
      return $store.state.childNode
    },
    childNodes(){
      return $store.state.childNodes
    }
  },
  methods: {
    moreService() {
      this.$router.push({
        path: '/cloudPlatform/AllService',
        query: {
          pName: this.pName
        }
      })
    },
    /*切换节点*/
    switchNodes() {
      this.$router.push({
        path: '/ServiceCentre/switchNode',
        query: {type: 2, pName: this.parName}
      })
    },
    /*银企服务*/
    moreLoan(){
      this.$router.push({
        path: '/loan/index',
        query: {
          pName: this.pName
        }
      })
    },
    /*银企服务详情*/
    bankEnterpriseServiceDetails(row){
      this.$router.replace({
        path: '/loan/serviceDetails',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          id: row.id,
          pName:this.childNode.name+'企业数字化服务云平台',
          backIndex:1,
        }
      })
    },
    handleClick(tab, event) {
      this.tablePage.currentPage=1;
      this.GetFirstAllGoods(tab.name.split('type')[1]);
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      window.scrollTo(0, this.$refs.recommends.offsetParent.offsetTop);
      this.GetFirstAllGoods(this.activeName.split('type')[1]);
    },
    /*产品详情*/
    productDetails(rows) {
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: rows.id,
          pName: this.pName,
          nextName: '服务平台'
        }
      })
    },
    /*服务平台首页(公共法律服务/企业申报/银企服务)*/
    getPlatformHome() {
      vsPlatformHome({
        cityCode: this.childNode.cityCode,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.bankEnterpriseService = res.content.yqzdGoodsLoanList;
        }
      })
    },
    /*精选一级分类下商品*/
    GetFirstAllGoods(id) {
      newGetFirstAllGoods({
        cityCode: this.childNode.parentCityCode,
        cityName: this.childNode.name,
        id: parseInt(id),
        pageNum: this.tablePage.currentPage,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        pageLimit:this.tablePage.pageSize,
        request: 'form',
      }).then(res => {
        if (res.code==200){
          this.tablePage.total=res.content.totalNum;
          this.recommends=res.content.goodsList;
        }
      })
    },
    /*获取服务分类*/
    getClassificationSonsOnes() {
      classificationSonsOnes().then(res => {
        if (res.code == 200) {
          this.tabList = res.content.newClass;
          this.activeName = 'type' + this.tabList[0].id;
          this.GetFirstAllGoods(this.tabList[0].id)
        }
      })
    },
    /*需求申报*/
    declaration(){
      this.$router.replace({
        path: '/declaration/index',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          pName:this.childNode.name+'企业数字化服务云平台',
          backIndex:1,
        }
      })
    },
    /*企业培育*/
    cultivation(){
      this.$router.replace({
        path: '/cultivation/index',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          pName:this.childNode.name+'企业数字化服务云平台',
          backIndex:1,
        }
      })
    },
    /*帮企云*/
    bangqiCloud(){
      window.open('https://bqy.bangq1.com/', '_blank')
    },
    /*公共法律服务*/
    legalService(url){
      window.open(url, '_blank')
    },
    /*项目辅导*/
    projectCoach(){
      let routeData = this.$router.resolve({
        name: "projectCoach",
        path: '/projectCoach/index',
        query: {
          pName:this.childNode.name+'企业数字化服务云平台',
        },
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getPlatformHome();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.parName = this.$route.query.parName;
    this.getClassificationSonsOnes();
  }
}
</script>
<style scoped>
.platform-container >>> .el-tabs__item {
  padding: 0 20px;
  height: 40px;
}

.platform-container >>> .el-tabs__item:hover {
  color: #666666;
}

.platform-container >>> .el-tabs__active-bar {
  left: 1px;
  width: 57px !important;
  background-color: #FE273B;
}

.platform-container >>> .el-tabs__item.is-active {
  color: #FE273B;
}

.platform-container >>> .el-tabs__nav-wrap::after {
  background-color: #EEEEEE;
}
</style>
<style scoped lang="scss">
.platform-container {
  background: #F5F5F5;

  .platform-content {
    padding: 0px 18%;
    min-width: 76rem;
    background: #F5F5F5;
    .title {
      font-size: 36px;
      cursor: context-menu;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-block-start: 0px;
      padding-top: 30px;
      .switch-btn {
        float: right;
        padding: 10px 20px;
        color: #FE273B;
        border: none;
        background: #ffffff;
        margin-bottom: 0px;
      }
    }

    .sub-module {
      margin-bottom: 20px;

      .col-12 {
        background: #ffffff;
        border-radius: 8px;

        .small-title {
          font-size: 20px;
          cursor: context-menu;
          margin-block-start: 0;
          margin-block-end: 0;

          .switch-btn {
            float: right;
            padding: 7px 0px;
            color: #333333;
            border: none;
            background: #ffffff;
            margin-bottom: 0px;

            .el-icon-right {
              font-weight: bold;
            }
          }
        }

        .left-row {
          .el-col-6 {
            padding-left: 10px;
            padding-right: 10px;

            .bg-purple {
              background: #F9F9F9;
              border-radius: 8px;
              padding: 20px;
              text-align: center;
              margin-top: 20px;

              p {
                color: #333333;
                font-size: 14px;
                margin-block-start: 0em;
                margin-block-end: 0em;
                padding: 10px 0px 0px;
                cursor: pointer;
              }

              .icon-red {
                width: 100%;
                height: 60px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              }

              .icon-mediate {
                background: url("~@/assets/img/cloud/mediate.png");
                width: 36px;
                height: 36px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }

              .icon-consulting {
                background: url("~@/assets/img/cloud/consulting.png");
                width: 36px;
                height: 36px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }

              .icon-subscribe {
                background: url("~@/assets/img/cloud/subscribe.png");
                width: 36px;
                height: 36px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }

              .icon-law {
                background: url("~@/assets/img/cloud/law.png");
                cursor: pointer;
                width: 36px;
                height: 36px;
                background-size: 100% 100%;
                position: absolute;
              }
            }
          }
        }

        .small-12 {
          padding: 20px;
          border: 1px solid #EEEEEE;
          margin: 8px 0;

          p {
            color: #666666;
            font-size: 14px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding: 0px 0px 8px;
            cursor: pointer;

            .el-divider {
              background-color: #999999;
            }
          }

          .bold-p {
            color: #333333;
            font-size: 16px;
          }

          .icon-red {
            width: 100%;
            height: 60px;
            cursor: pointer;

            .icon-ECS {
              background: url("~@/assets/img/cloud/ECS.png");
              width: 36px;
              height: 36px;
              background-size: 100% 100%;
              position: absolute;
            }

            .icon-storage {
              background: url("~@/assets/img/cloud/storage.png");
              width: 36px;
              height: 36px;
              background-size: 100% 100%;
              position: absolute;
            }

            .icon-server {
              background: url("~@/assets/img/cloud/server.png");
              width: 36px;
              height: 36px;
              background-size: 100% 100%;
              position: absolute;
            }

            .icon-MySQL {
              background: url("~@/assets/img/cloud/MySQL.png");
              width: 36px;
              height: 36px;
              background-size: 100% 100%;
              position: absolute;
            }
          }

          .p-bold {
            color: #333333;
            font-size: 16px;
            padding: 0px 0px 5px 45px;
          }

          .default-p {
            color: #666666;
            font-size: 14px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding: 0px 0px 2px 45px;
          }
        }
      }

      .el-col-4 {
        padding-left: 10px;
        padding-right: 10px;

        .bg-purple {
          background: white;
          border-radius: 8px;
          text-align: center;
          padding: 5px 0px 20px;

          p {
            color: #333333;
            font-size: 18px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding: 5px 0px 0px;
            cursor: pointer;

            .el-icon-right {
              color: #FE273B;
              font-weight: bold;
            }
          }

          .icon-red {
            width: 100%;
            height: 64px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding-top: 40px;
          }

          .icon-coach {
            background: url("~@/assets/img/cloud/coach.png");
            width: 64px;
            height: 64px;
            background-size: 100% 100%;
            position: absolute;
            cursor: pointer;
          }

          .icon-cultivation {
            background: url("~@/assets/img/cloud/cultivation.png");
            width: 64px;
            height: 64px;
            background-size: 100% 100%;
            position: absolute;
            cursor: pointer;
          }

          .icon-declare {
            background: url("~@/assets/img/cloud/declare.png");
            width: 64px;
            height: 64px;
            background-size: 100% 100%;
            position: absolute;
            cursor: pointer;
          }

          .statistics {
            color: #666666;
            padding: 5px 0px;
            font-size: 14px;

            span {
              padding-right: 5px;
            }
          }
        }
      }

      .el-col-24 {
        background: #ffffff;
        border-radius: 8px;

        .small-title {
          font-size: 20px;
          cursor: context-menu;
          margin-block-start: 0;
          margin-block-end: 0;

          .switch-btn {
            float: right;
            padding: 7px 0px;
            color: #333333;
            border: none;
            background: #ffffff;
            margin-bottom: 0px;

            .el-icon-right {
              font-weight: bold;
            }
          }
        }

        .el-tabs {
          margin-top: 10px;
          padding: 0px 20px;
        }

        .recommend {
          padding: 0px 20px;

          .el-col-4 {
            width: 20%;
            padding-bottom: 20px;
            min-height: 338px;

            .recommend-title{
              margin-block-start: 0;
              margin-block-end: 0;
              font-size: 16px;
              color: #333333;
              padding: 0px 0px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;
            }

            .recommend-price {
              font-size: 18px;
              color: #FE273B;
              margin-block-start: 0;
              margin-block-end: 0;

              span {
                font-size: 14px;
                padding-right: 3px;
              }
            }

            .preferential-amount {
              cursor: pointer;
              line-height: 24px;
              text-align: center;
              font-size: 14px;
              color: #FE273B;

              .preferential {
                background: url("~@/assets/img/cloud/coupon.png");
                width: 120px;
                height: 24px;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>